import { checkAuth } from "@/shared/auth/utils/checkAuth";
import { CheckAuthAndRedirect } from "@/widgets/check-auth-and-redirect";
import { TheFooter } from "@/widgets/footer";
import { TheHeader } from "@/widgets/header";
import { TheSidebar } from "@/widgets/sidebar";
import { CssBaseline, Stack } from "@mui/material";

import {
  Outlet,
  createFileRoute,
  redirect,
  useRouter,
} from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/_auth_requeired")({
  beforeLoad: async () => {
    const isAuthenticated = await checkAuth();
    if (!isAuthenticated) {
      throw redirect({
        to: "/login",
      });
    }
  },
  component: () => {
    const router = useRouter();

    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    const handleMobileSidebarOpen = () => {
      setMobileSidebarOpen(true);
    };
    const handleMobileSidebarClose = () => {
      setMobileSidebarOpen(false);
    };

    useEffect(() => {
      // ルート変更時にDrawerを閉じる
      const unsubscribe = router.subscribe("onBeforeNavigate", () => {
        setMobileSidebarOpen(false);
      });

      return () => {
        unsubscribe();
      };
    }, [router]);

    return (
      <CheckAuthAndRedirect>
        <Stack height="100vh" sx={{ overflow: "hidden" }}>
          <CssBaseline />
          <TheHeader onMobileSidebarOpen={handleMobileSidebarOpen} />
          <Stack
            direction="row"
            alignItems="stretch"
            flexGrow={1}
            overflow="auto"
          >
            <TheSidebar
              mobileOpen={mobileSidebarOpen}
              onMobileClose={handleMobileSidebarClose}
            />
            <Stack
              flexGrow={1}
              alignItems="stretch"
              sx={{
                paddingTop: { xs: 3, sm: 4 },
                overflow: { xs: "hidden auto", sm: "auto" },
              }}
            >
              <Outlet />
              <TheFooter flexShrink={0} />
            </Stack>
          </Stack>
        </Stack>
      </CheckAuthAndRedirect>
    );
  },
});
